/**
 * Simple Facebook Pixel utility
 */

// Simple helper to ensure fbq is available
const isFbqAvailable = () => {
  return typeof window !== 'undefined' && typeof window.fbq === 'function';
};

// Facebook Pixel utility object
const FacebookPixel = {
  /**
   * Track a page view
   */
  pageview: () => {
    if (!isFbqAvailable()) return;
    
    window.fbq('track', 'PageView');
    
    if (process.env.NODE_ENV === 'development') {
      console.log('FB Pixel PageView');
    }
  },

  /**
   * Track a custom event
   * @param {string} event - The event name
   * @param {Object} [params] - Optional event parameters
   */
  event: (event, params = {}) => {
    if (!isFbqAvailable()) return;
    
    window.fbq('trackCustom', event, params);
    
    if (process.env.NODE_ENV === 'development') {
      console.log(`FB Pixel Custom Event: ${event}`, params);
    }
  },

  /**
   * Track a standard event
   * @param {string} event - The standard event name
   * @param {Object} [params] - Optional event parameters
   */
  standardEvent: (event, params = {}) => {
    if (!isFbqAvailable()) return;
    
    window.fbq('track', event, params);
    
    if (process.env.NODE_ENV === 'development') {
      console.log(`FB Pixel Standard Event: ${event}`, params);
    }
  }
};

export default FacebookPixel; 